import { render, staticRenderFns } from "./RedeemListTable.vue?vue&type=template&id=56f3e19c&"
import script from "./RedeemListTable.vue?vue&type=script&lang=js&"
export * from "./RedeemListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports